import { useEffect, useContext } from "react"
import { useFormikContext } from "formik"
import { DateTime } from "luxon"
import { UserContext } from "../../../context/userContext"
import { FormContext } from "../../../context/formContext"

import styles from "../../../styles/Form.module.css"

export default function DateChangedByRol({ field, index }) {
  const formik = useFormikContext()
  const userCtx = useContext(UserContext)
  const form = useContext(FormContext)

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    const now = DateTime.now().toISO() || "not-set"
    if (
      field.field_name === "date_modified_staff" &&
      userCtx.session.user.staff_role < 9
    ) {
      formik.setFieldValue(field.field_name, now)
    }

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={styles.hidden} style={{ order: index }}>
      <input
        type="hidden"
        name={field.field_name}
        value={formik.values[field.field_name]}
      />
    </div>
  )
}
